module.exports = __webpack_public_path__ + "static/scale-model-of-pier-55-in-seattle-washington-f3e663e79c2c3dfee65622d28825a8e4.png";